<template>
  <h2>Plants Page</h2>
</template>

<script>
export default {

}
</script>

<style>

</style>